<template>
    <v-container v-if="employeeId !== null">
        <phone-calls-vue :id="employeeId"></phone-calls-vue>
        <appointment-result-vue :id="employeeId"></appointment-result-vue>
        <callbacks-vue :id="employeeId"></callbacks-vue>
        <week-overall-vue :id="employeeId"></week-overall-vue>
    </v-container>
    <v-container v-else>
        Loading...
    </v-container>
</template>

<script>
import axios from '../../../utils/axios'
import AppointmentResultVue from './AppointmentResult.vue'
import CallbacksVue from './Callbacks.vue'
import PhoneCallsVue from './PhoneCalls.vue'
import WeekOverallVue from './WeekOverall.vue'

export default {
    components: { PhoneCallsVue, AppointmentResultVue, CallbacksVue, WeekOverallVue },
    data() {
        return {
            employeeId: null
        }
    },
    async created() {
        // console.log(JSON.parse(window.localStorage.getItem('user')).email);
        try {
            const response = await axios.get('api/admin/employees/employee-by-email', {
                params: {
                    email: JSON.parse(window.localStorage.getItem('user')).email
                }
            });
            // Correctly assign the employee ID from the response data
            this.employeeId = `${response.data.id}`;
        } catch (error) {
            if (error.response && error.response.status === 404) {
                console.error('Employee not found');
            } else {
                console.error('An error occurred:', error);
            }
        }
    }
}
</script>
